export const MAX_GUESSES = 10
export const OLDEST_ARCHIVE_DATE = '2025-12-00' // YYYY-MM-DD format
